// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanLayoutWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload } from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyFloorPlanLayoutUploadRequestWebDto,
  UserPropertyFloorPlanLayoutUploadResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface UploadParams {
  floorPlanId: string;
  sourceUrl?: string;
}

export interface RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Args {
  getParams: UploadParams;
  postData: UserPropertyFloorPlanLayoutUploadRequestWebDto;
}

export type RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Options = UseMutationOptions<
  UserPropertyFloorPlanLayoutUploadResponseWebDto,
  unknown,
  RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Args
>;

/**
 * Upload a property layout
 */
export const useRentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload_Args) =>
      RentalManagerUserPropertyFloorPlanLayoutWebApiHandler_upload(args.getParams, args.postData, httpClient),
  });
};
